// Functional parity helpers split from useProjectData.js; keep persistence flow in the hook.
export const DEFAULT_TEMPLATE = [
  { id: "t1", label: "Sıcaklık (°C)", bind: "sicaklik", visible: true, order: 1 },
  { id: "t2", label: "Atmosfer (hPa)", bind: "atm", visible: true, order: 2 },
  { id: "t3", label: "SPC (µS/cm)", bind: "spc", visible: true, order: 3 },
  { id: "t4", label: "TDS (mg/L)", bind: "tds", visible: true, order: 4 },
  { id: "t5", label: "Tuzluluk (ppt)", bind: "sal", visible: true, order: 5 },
  { id: "t6", label: "pH", bind: "ph", visible: true, order: 6 },
  { id: "t7", label: "Notlar", bind: "notMetni", visible: true, order: 7, type: "textarea" },
];

export function generateTemplateRowId(seed = "row") {
  const safeSeed = String(seed || "row")
    .trim()
    .toLocaleLowerCase("tr-TR")
    .replace(/[^a-z0-9_]+/g, "_")
    .replace(/^_+|_+$/g, "");
  const randomPart = Math.random().toString(36).slice(2, 8);
  return `c_${safeSeed || "row"}_${Date.now()}_${randomPart}`;
}

export function normalizeTemplateRows(rows, fallbackRows = DEFAULT_TEMPLATE) {
  const source =
    Array.isArray(rows) && rows.length
      ? rows
      : Array.isArray(fallbackRows)
        ? fallbackRows
        : [];

  const usedIds = new Set();

  return source.map((row, index) => {
    const bind = row?.bind ?? null;
    const label = String(row?.label || "").trim() || `Alan ${index + 1}`;
    let id = String(row?.id || "").trim();

    if (!id || usedIds.has(id)) {
      id = generateTemplateRowId(bind || label || index + 1);
    }
    usedIds.add(id);

    return {
      ...row,
      id,
      label,
      bind,
      visible: row?.visible !== false,
      type: row?.type || (bind === "notMetni" ? "textarea" : "text"),
      order: index + 1,
    };
  });
}

export function isAuthzError(error) {
  const status = error?.response?.status;
  return status === 401 || status === 403;
}
